export enum ROUTES {
  INDEX = '/',
  AIRDROP = '/airdrop',
  LVUSD = '/LVUSD',
  LVMON = '/LVMON',
  LVMON_REDEEM = '/LVMON/Redeem',
  FAIRLAUNCH = '/fairlaunch',
  EARN = '/earn',
  PRIVACY_POOLS = '/privacy-pools',
  PORTFOLIO = '/portfolio',
  LEADERBOARD = '/leaderboard',
  COMPETITION = '/competition',
  // PCS1 = '/competition/PCS1',
}
export const getSubRouteParent = (subRoute: string): ROUTES | null => {
  switch (subRoute) {
    default:
      if (subRoute.startsWith(`${ROUTES.PORTFOLIO}/`)) return ROUTES.PORTFOLIO;
      if (subRoute.startsWith(`${ROUTES.LVMON}/`)) return ROUTES.LVMON;
      if (subRoute.startsWith(`${ROUTES.FAIRLAUNCH}/`)) {
        return ROUTES.FAIRLAUNCH;
      }

      return null;
  }
};
